/**
 * `/invite/:token` — the page a shared-recipe invite email opens (PLAN-COLLAB
 * E2).
 *
 * Inside the app shell, unlike `/s/:token`: the person opening it is about to
 * become a member of a recipe in their own workspace, so the workspace is what
 * they should land in. A guest is sent to sign in first and brought back here,
 * because an invite is bound to an address and only a session can say whose.
 */

import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';
import { InvitePage } from '@/components/recipe/invite-page';
import { inviteAppPath } from '@/shared-recipes/protocol';

export const Route = createFileRoute('/invite/$token')({
  component: InviteRoute,
});

function InviteRoute() {
  const { token } = Route.useParams();
  const navigate = useNavigate();
  const onSignIn = useCallback(() => {
    void navigate({ to: '/signin', search: { next: inviteAppPath(token) }, replace: true });
  }, [navigate, token]);
  const onOpenRecipe = useCallback(
    (recipeId: string) => {
      // Replacing this entry: Back from the recipe should not land on an
      // invite that has already been answered.
      void navigate({ to: '/recipes/$recipeId', params: { recipeId }, replace: true });
    },
    [navigate],
  );
  const onNotNow = useCallback(() => {
    void navigate({ to: '/recipes' });
  }, [navigate]);
  return (
    <InvitePage token={token} onOpenRecipe={onOpenRecipe} onSignIn={onSignIn} onNotNow={onNotNow} />
  );
}
